import { EmissionConsultModule } from './emission/emission-consult.module';
import { NgModule } from "@angular/core";

@NgModule({
  imports: [
    EmissionConsultModule,
  ]
})
export class EmissionCreditConsultModule {}
